"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = exports.InputWrapper = exports.Container = exports.Wrapper = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _typography = _interopRequireDefault(require("@decisiv/design-tokens/lib/typography"));

var _spacing = _interopRequireDefault(require("@decisiv/design-tokens/lib/spacing"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "styles__Wrapper",
  componentId: "h9lqjf-0"
})(["flex:1;& > div > div:first-of-type{height:auto;& > div:first-of-type{padding-right:", ";padding-bottom:", ";}}"], (0, _rem.default)(_spacing.default.base * 0.2), (0, _rem.default)(_spacing.default.base * 0.6));

exports.Wrapper = Wrapper;

var Container = _styledComponents.default.div.withConfig({
  displayName: "styles__Container",
  componentId: "h9lqjf-1"
})(["display:flex;flex:1;gap:", ";flex-direction:row;flex-wrap:wrap;width:100%;"], (0, _rem.default)(_spacing.default.base * 0.5));

exports.Container = Container;

var InputWrapper = _styledComponents.default.div.withConfig({
  displayName: "styles__InputWrapper",
  componentId: "h9lqjf-2"
})(["display:flex;flex:1;position:relative;"]);

exports.InputWrapper = InputWrapper;

var Input = _styledComponents.default.input.withConfig({
  displayName: "styles__Input",
  componentId: "h9lqjf-3"
})(["flex:1;min-width:", ";font-family:", ";font-size:", ";font-weight:", ";padding-right:", ";border:none;&:active,&:focus{outline:none;border:none;}", " ", ""], (0, _rem.default)(_spacing.default.base * 7), _typography.default.typeface.default, (0, _rem.default)(_typography.default.size.alias.default), _typography.default.weight.alias.default, (0, _rem.default)(_spacing.default.base * 3.2), function (_ref) {
  var isVisible = _ref.isVisible;
  return !isVisible && (0, _styledComponents.css)(["padding:0;border:none;flex:0;opacity:0;width:0;min-width:0;height:0;"]);
}, function (_ref2) {
  var isVisible = _ref2.isVisible;
  return isVisible && (0, _styledComponents.css)(["&:not(:placeholder-shown) + button{display:block !important;}"]);
});

exports.Input = Input;